let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6KbH2")).then(() => parcelRequire('3pT5A'));